import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { useState } from "react";
import { DeleteModal } from "../../components";
import { useArticles } from "../../store/useArticles";
import { useNavigate } from "react-router-dom";

export const ArticleCategoriesTable = () => {
  /** Hooks */
  const { categories, deleteArticleCategory } = useArticles();
  const navigate = useNavigate();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3">
              Title
            </th>
            <th scope="col" className="px-6 py-3 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {categories?.map((item) => {
            return (
              <tr key={item._id} className="bg-white border-b">
                <td className="px-6 py-4 whitespace-nowrap">{item?.title}</td>
                <td className="px-6 py-4 flex items-center justify-end cursor-pointer">
                  <EditIcon
                    onClick={() =>
                      navigate(`/edit-article-category/${item?._id}`)
                    }
                    className="mr-7"
                  />
                  <TrashIcon
                    onClick={() => {
                      const confirmDelete = window.confirm(
                        "Are you sure you want to delete this category?"
                      );
                      if (confirmDelete) {
                        deleteArticleCategory(item._id);
                      }
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
